import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div
      className="fixed bottom-5 right-5 z-50"
      style={{ position: "fixed", bottom: "20px", right: "20px" }}
    >
      <button
        type="button"
        onClick={scrollToTop}
        className={`
          bg-woost-blue text-white rounded-full p-3 shadow-lg
          hover:bg-woost-blue-dark focus:outline-none
          transition-all duration-300 transform
          ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"}
        `}
        aria-label="Scroll to top"
      >
        <ChevronUp size={24} />
      </button>
    </div>
  );
};

export default ScrollToTop;
